// extracted by mini-css-extract-plugin
export var aboutPagePeopleGridItem = "about_page_people_grid_item-module--aboutPagePeopleGridItem--NPIfC";
export var aboutPagePeopleGridItemWrapper = "about_page_people_grid_item-module--aboutPagePeopleGridItemWrapper--hEB6d";
export var jobTitle = "about_page_people_grid_item-module--jobTitle--pNVj3";
export var textOverlay = "about_page_people_grid_item-module--textOverlay--JPy8H";